// import React, { useState, useEffect } from "react";
// import axios from "axios";

// import {
//   Tooltip,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
// } from "@mui/material";

// import { Pagination, Stack } from "@mui/material";
// import AlertDialogForm from "./alertdialog";
// import {
//   GETIL2BYEMPID,
//   VAVE,
//   DOWNLOAD2B2FILE,
// } from "../../../Pages/AppConstant";
// import approvedImage from "../../../assets/images/approved_image.jpg";
// import rejectedImage from "../../../assets/images/rejected_image.jpg";
// import DownloadIcon from "@mui/icons-material/Download";
// import ExcelJS from "exceljs";
// import loadergif from "../../../assets/images/BG-switch loader_2.gif";

// const getStatusColor = (status) => {
//   switch (status) {
//     case "accepted":
//       return "green";
//     case "rejected":
//       return "red";
//     case "pending":
//       return "orange";
//     default:
//       return "gray";
//   }
// };

// const StatusDot = ({ status, name, onClick }) => (
//   <Tooltip title={`Status: ${status} (${name})`} arrow>
//     <span
//       onClick={onClick}
//       style={{
//         display: "inline-block",
//         width: "22px",
//         height: "22px",
//         borderRadius: "50%",
//         backgroundColor: getStatusColor(status),
//         margin: "auto",
//         cursor: "pointer",
//       }}
//     />
//   </Tooltip>
// );

// const IdeaTable = ({ requests }) => {
//   const [openDialog, setOpenDialog] = useState(false);
//   const [selectedRequest, setSelectedRequest] = useState(null);
//   const [selectedApprover, setSelectedApprover] = useState(null);
//   const [allIdeas, setAllIdeas] = useState([]);
//   const [isloading, setIsloading] = useState(false);

//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10; // Change as needed
//   const [searchQuery, setSearchQuery] = useState("");

//   const isIdeaUpdatedToday = (idea) => {
//     if (!idea?.url_2b2_created_timestamp) return false;

//     const updatedDate = new Date(idea.url_2b2_created_timestamp)
//       .toISOString()
//       .split("T")[0];

//     return updatedDate === "2025-11-20";
//   };

//   const addStampImageToCell = async (
//     workbook,
//     worksheet,
//     row,
//     col,
//     isApproved
//   ) => {
//     try {
//       const imageUrl = isApproved ? approvedImage : rejectedImage;

//       // Convert the imported image to a blob URL or base64
//       const response = await fetch(imageUrl);
//       const blob = await response.blob();
//       const arrayBuffer = await blob.arrayBuffer();

//       const imageId = workbook.addImage({
//         buffer: arrayBuffer,
//         extension: "png",
//       });

//       worksheet.addImage(imageId, {
//         tl: { col: col - 1, row: row - 1, offset: 2 }, // 2px offset from top-left
//         br: { col: col, row: row, offset: 2 }, // 2px offset from bottom-right
//       });
//     } catch (error) {
//       console.error("Error adding stamp image:", error);
//     }
//   };

//   const handleDotClick = (req, approver) => {
//     setSelectedRequest(req);
//     setSelectedApprover(approver);
//     setOpenDialog(true);
//   };

//   const handleCloseDialog = () => {
//     setOpenDialog(false);
//   };

//   const downloadApi = async (request) => {
//     try {
//       setIsloading(true);
//       // Fetch the uploaded Excel file from API
//       const response = await axios({
//         method: "post",
//         url: VAVE + DOWNLOAD2B2FILE,
//         headers: { "Content-Type": "application/x-www-form-urlencoded" },
//         data: { idea_id: request.ideaids },
//         responseType: "blob",
//       });

//       if (response.data.size === 14) {
//         alert("No Data Available");
//         setIsloading(false);
//         return;
//       }

//       // Load the uploaded Excel file
//       const workbook = new ExcelJS.Workbook();
//       const arrayBuffer = await response.data.arrayBuffer();
//       await workbook.xlsx.load(arrayBuffer);

//       const worksheet = workbook.getWorksheet(1);

//       const currentIdea = allIdeas.find(
//         (idea) =>
//           idea.idea_unique_id === request.idea_unique_id ||
//           idea.idea_id === request.ideaids
//       );

//       if (currentIdea) {
//         const isUpdatedToday = isIdeaUpdatedToday(currentIdea);

//         if (isUpdatedToday) {
//           // alert("today" + isUpdatedToday);
//           await addOldStampImagesToWorksheet(workbook, worksheet, request);
//         } else {
//           //  alert("not-today" + isUpdatedToday);
//           updateWorksheetStamps(worksheet, request);

//           await addStampImagesToWorksheet(workbook, worksheet, request);
//         }
//       }

//       // await addStampImagesToWorksheet(workbook, worksheet, request);
//       // await addStampImagesToWorksheet(workbook, worksheet, request);

//       // Export and download the modified worksheet
//       const buffer = await workbook.xlsx.writeBuffer();
//       const blob = new Blob([buffer], {
//         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//       });

//       const url = URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute(
//         "download",
//         `Idea_${request.idea_unique_id}_Report.xlsx`
//       );
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       URL.revokeObjectURL(url);
//       setIsloading(false);
//     } catch (error) {
//       console.error("Download failed:", error);
//       alert("Download failed: " + error.message);
//       setIsloading(false);
//     }
//   };

//   const addOldStampImagesToWorksheet = async (workbook, worksheet, idea) => {
//     try {
//       console.log("Adding stamp images to worksheet");

//       // PD Department Stamp
//       if (
//         idea.il2_pd_status &&
//         idea.il2_pd_status.toLowerCase() !== "inprogress"
//       ) {
//         const isApproved =
//           idea.il2_pd_status.toLowerCase() === "accepted" ||
//           idea.il2_pd_status.toLowerCase() === "approved";
//         await addStampImageToCell(workbook, worksheet, 79, 12, isApproved); // H68
//       }

//       // S&SC Department Stamp
//       if (
//         idea.il2_sourcing_status &&
//         idea.il2_sourcing_status.toLowerCase() !== "inprogress"
//       ) {
//         const isApproved =
//           idea.il2_sourcing_status.toLowerCase() === "accepted" ||
//           idea.il2_sourcing_status.toLowerCase() === "approved";
//         await addStampImageToCell(workbook, worksheet, 79, 14, isApproved); // J68
//       }

//       // Marketing Department Stamp
//       if (
//         idea.il2_marketing_status &&
//         idea.il2_marketing_status.toLowerCase() !== "inprogress"
//       ) {
//         const isApproved =
//           idea.il2_marketing_status.toLowerCase() === "accepted" ||
//           idea.il2_marketing_status.toLowerCase() === "approved";
//         await addStampImageToCell(workbook, worksheet, 79, 18, isApproved); // N68
//       }

//       // Quality Department Stamp
//       if (
//         idea.il2_quality_status &&
//         idea.il2_quality_status.toLowerCase() !== "inprogress"
//       ) {
//         const isApproved =
//           idea.il2_quality_status.toLowerCase() === "accepted" ||
//           idea.il2_quality_status.toLowerCase() === "approved";
//         await addStampImageToCell(workbook, worksheet, 79, 22, isApproved); // R68
//       }

//       //finance
//       if (
//         idea.il2_costing_status &&
//         idea.il2_costing_status.toLowerCase() !== "inprogress"
//       ) {
//         const isApproved =
//           idea.il2_costing_status.toLowerCase() === "accepted" ||
//           idea.il2_costing_status.toLowerCase() === "approved";
//         await addStampImageToCell(workbook, worksheet, 79, 20, isApproved); // R68
//       }
//       //manuf
//       if (
//         idea.il2_manuf_status &&
//         idea.il2_manuf_status.toLowerCase() !== "inprogress"
//       ) {
//         const isApproved =
//           idea.il2_manuf_status.toLowerCase() === "accepted" ||
//           idea.il2_manuf_status.toLowerCase() === "approved";
//         await addStampImageToCell(workbook, worksheet, 79, 16, isApproved); // R68
//       }
//       console.log("Stamp images added successfully");
//     } catch (error) {
//       console.error("Error adding stamp images:", error);
//     }
//   };

//   const addStampImagesToWorksheet = async (workbook, worksheet, idea) => {
//     try {
//       console.log("Adding stamp images to worksheet");

//       // PD Department Stamp
//       if (
//         idea.il2_pd_status &&
//         idea.il2_pd_status.toLowerCase() !== "inprogress"
//       ) {
//         const isApproved =
//           idea.il2_pd_status.toLowerCase() === "accepted" ||
//           idea.il2_pd_status.toLowerCase() === "approved";
//         await addStampImageToCell(workbook, worksheet, 68, 8, isApproved); // H68
//       }

//       // S&SC Department Stamp
//       if (
//         idea.il2_sourcing_status &&
//         idea.il2_sourcing_status.toLowerCase() !== "inprogress"
//       ) {
//         const isApproved =
//           idea.il2_sourcing_status.toLowerCase() === "accepted" ||
//           idea.il2_sourcing_status.toLowerCase() === "approved";
//         await addStampImageToCell(workbook, worksheet, 68, 10, isApproved); // J68
//       }

//       // Marketing Department Stamp
//       if (
//         idea.il2_marketing_status &&
//         idea.il2_marketing_status.toLowerCase() !== "inprogress"
//       ) {
//         const isApproved =
//           idea.il2_marketing_status.toLowerCase() === "accepted" ||
//           idea.il2_marketing_status.toLowerCase() === "approved";
//         await addStampImageToCell(workbook, worksheet, 68, 14, isApproved); // N68
//       }

//       // Quality Department Stamp
//       if (
//         idea.il2_quality_status &&
//         idea.il2_quality_status.toLowerCase() !== "inprogress"
//       ) {
//         const isApproved =
//           idea.il2_quality_status.toLowerCase() === "accepted" ||
//           idea.il2_quality_status.toLowerCase() === "approved";
//         await addStampImageToCell(workbook, worksheet, 68, 18, isApproved); // R68
//       }

//       //finance
//       if (
//         idea.il2_costing_status &&
//         idea.il2_costing_status.toLowerCase() !== "inprogress"
//       ) {
//         const isApproved =
//           idea.il2_costing_status.toLowerCase() === "accepted" ||
//           idea.il2_costing_status.toLowerCase() === "approved";
//         await addStampImageToCell(workbook, worksheet, 68, 16, isApproved); // R68
//       }
//       //manuf
//       if (
//         idea.il2_manuf_status &&
//         idea.il2_manuf_status.toLowerCase() !== "inprogress"
//       ) {
//         const isApproved =
//           idea.il2_manuf_status.toLowerCase() === "accepted" ||
//           idea.il2_manuf_status.toLowerCase() === "approved";
//         await addStampImageToCell(workbook, worksheet, 68, 12, isApproved); // R68
//       }
//       console.log("Stamp images added successfully");
//     } catch (error) {
//       console.error("Error adding stamp images:", error);
//     }
//   };

//   const updateWorksheetStamps = (worksheet, idea) => {
//     try {
//       console.log("Updating worksheet with idea data:", idea);

//       // PD Department - Only update values, preserve all existing styles
//       if (
//         idea.il2_pd_status &&
//         idea.il2_pd_status.toLowerCase() !== "inprogress"
//       ) {
//         const isApproved =
//           idea.il2_pd_status.toLowerCase() === "accepted" ||
//           idea.il2_pd_status.toLowerCase() === "approved";

//         // Update comment cell - only value
//         const commentCell = worksheet.getCell(66, 8);
//         commentCell.value = idea.il2_pd_comment || "";

//         // Update status cell - only value
//         const statusCell = worksheet.getCell(68, 8);
//         statusCell.value = `${isApproved ? "APPROVED" : "REJECTED"}\nby ${
//           idea.il2_pd_name || ""
//         }`;

//         // Only ensure wrap text is enabled
//         statusCell.alignment = { ...statusCell.alignment, wrapText: true };
//       } else {
//         const statusCell = worksheet.getCell(68, 8);
//         statusCell.value = idea.il2_pd_status || "";
//       }

//       // S&SC Department
//       if (
//         idea.il2_sourcing_status &&
//         idea.il2_sourcing_status.toLowerCase() !== "inprogress"
//       ) {
//         const isApproved =
//           idea.il2_sourcing_status.toLowerCase() === "accepted" ||
//           idea.il2_sourcing_status.toLowerCase() === "approved";

//         const commentCell = worksheet.getCell(66, 10);
//         commentCell.value = idea.il2_sourcing_comment || "";

//         const statusCell = worksheet.getCell(68, 10);
//         statusCell.value = `${isApproved ? "APPROVED" : "REJECTED"}\nby ${
//           idea.il2_sourcing_name || ""
//         }`;
//         statusCell.alignment = { ...statusCell.alignment, wrapText: true };
//       } else {
//         const statusCell = worksheet.getCell(68, 10);
//         statusCell.value = idea.il2_sourcing_status || "";
//       }

//       // Marketing Department
//       if (
//         idea.il2_marketing_status &&
//         idea.il2_marketing_status.toLowerCase() !== "inprogress"
//       ) {
//         const isApproved =
//           idea.il2_marketing_status.toLowerCase() === "accepted" ||
//           idea.il2_marketing_status.toLowerCase() === "approved";

//         const commentCell = worksheet.getCell(66, 14);
//         commentCell.value = idea.il2_marketing_comment || "";

//         const statusCell = worksheet.getCell(68, 14);
//         statusCell.value = `${isApproved ? "APPROVED" : "REJECTED"}\nby ${
//           idea.il2_marketing_name || ""
//         }`;
//         statusCell.alignment = { ...statusCell.alignment, wrapText: true };
//       } else {
//         const statusCell = worksheet.getCell(68, 14);
//         statusCell.value = idea.il2_marketing_status || "";
//       }

//       // Quality Department
//       if (
//         idea.il2_quality_status &&
//         idea.il2_quality_status.toLowerCase() !== "inprogress"
//       ) {
//         const isApproved =
//           idea.il2_quality_status.toLowerCase() === "accepted" ||
//           idea.il2_quality_status.toLowerCase() === "approved";

//         const commentCell = worksheet.getCell(66, 18);
//         commentCell.value = idea.il2_quality_comment || "";

//         const statusCell = worksheet.getCell(68, 18);
//         statusCell.value = `${isApproved ? "APPROVED" : "REJECTED"}\nby ${
//           idea.il2_quality_name || ""
//         }`;
//         statusCell.alignment = { ...statusCell.alignment, wrapText: true };
//       } else {
//         const statusCell = worksheet.getCell(68, 18);
//         statusCell.value = idea.il2_quality_status || "";
//       }

//       if (
//         idea.il2_manuf_status &&
//         idea.il2_manuf_status.toLowerCase() !== "inprogress"
//       ) {
//         const isApproved =
//           idea.il2_manuf_status.toLowerCase() === "accepted" ||
//           idea.il2_manuf_status.toLowerCase() === "approved";

//         const commentCell = worksheet.getCell(66, 12);
//         commentCell.value = idea.il2_manuf_comment || "";

//         const statusCell = worksheet.getCell(68, 12);
//         statusCell.value = `${isApproved ? "APPROVED" : "REJECTED"}\nby ${
//           idea.il2_manuf_name || ""
//         }`;
//         statusCell.alignment = { ...statusCell.alignment, wrapText: true };
//       } else {
//         const statusCell = worksheet.getCell(68, 12);
//         statusCell.value = idea.il2_manuf_status || "";
//       }

//       if (
//         idea.il2_costing_status &&
//         idea.il2_costing_status.toLowerCase() !== "inprogress"
//       ) {
//         const isApproved =
//           idea.il2_costing_status.toLowerCase() === "accepted" ||
//           idea.il2_costing_status.toLowerCase() === "approved";

//         const commentCell = worksheet.getCell(66, 16);
//         commentCell.value = idea.il2_costing_comment || "";

//         const statusCell = worksheet.getCell(68, 16);
//         statusCell.value = `${isApproved ? "APPROVED" : "REJECTED"}\nby ${
//           idea.il2_costing_name || ""
//         }`;
//         statusCell.alignment = { ...statusCell.alignment, wrapText: true };
//       } else {
//         const statusCell = worksheet.getCell(68, 16);
//         statusCell.value = idea.il2_costing_status || "";
//       }
//     } catch (error) {
//       console.error("Error updating worksheet stamps:", error);
//     }
//   };
//   useEffect(() => {
//     fetchIdeas();
//   }, []);

//   const fetchIdeas = async () => {
//     try {
//       const response = await axios.get(VAVE + GETIL2BYEMPID, {
//         headers: {
//           "Content-Type": "application/x-www-form-urlencoded",
//         },
//       });

//       const ideas = response.data.data || [];
//       setAllIdeas(ideas);
//     } catch (error) {
//       console.error("Error fetching ideas:", error);
//     }
//   };

//   const updatedRequests = allIdeas.map((req) => {
//     const approvers = [];

//     if (req.il2_pd_name) {
//       approvers.push({
//         name: req.il2_pd_name,
//         status: req.il2_pd_status,
//         comment: req.il2_pd_comment,
//         role: "PD",
//       });
//     }

//     if (req.il2_sourcing_name) {
//       approvers.push({
//         name: req.il2_sourcing_name,
//         status: req.il2_sourcing_status,
//         comment: req.il2_sourcing_comment,
//         role: "Sourcing",
//       });
//     }

//     if (req.il2_marketing_name) {
//       approvers.push({
//         name: req.il2_marketing_name,
//         status: req.il2_marketing_status,
//         comment: req.il2_marketing_comment,
//         role: "Marketing",
//       });
//     }

//     if (req.il2_quality_name) {
//       approvers.push({
//         name: req.il2_quality_name,
//         status: req.il2_quality_status,
//         comment: req.il2_quality_comment,
//         role: "Quality",
//       });
//     }

//     if (req.il2_manuf_name) {
//       approvers.push({
//         name: req.il2_manuf_name,
//         status: req.il2_manuf_status,
//         comment: req.il2_manuf_comment,
//         role: "Manuf",
//       });
//     }

//     if (req.il2_costing_name) {
//       approvers.push({
//         name: req.il2_costing_name,
//         status: req.il2_costing_status,
//         comment: req.il2_costing_comment,
//         role: "Costing",
//       });
//     }

//     return {
//       ...req,
//       approvers,
//     };
//   });

//   const approverNames = Array.from(
//     new Set(
//       updatedRequests.flatMap((req) =>
//         req.approvers.map((approver) => approver.name || approver.role)
//       )
//     )
//   );

//   const totalPages = Math.ceil(updatedRequests.length / itemsPerPage);
//   const startIndex = (currentPage - 1) * itemsPerPage;
//   const filteredIdeas = updatedRequests.filter((item) => {
//     const query = searchQuery.toLowerCase();
//     const matchesSearch = Object.values(item).some((value) =>
//       String(value).toLowerCase().includes(query)
//     );

//     return matchesSearch;
//   });
//   const currentData = filteredIdeas.slice(
//     startIndex,
//     startIndex + itemsPerPage
//   );

//   const handleButtonClick = (filter) => {

//   };

//   const handlePageChange = (page) => {
//     if (page >= 1 && page <= totalPages) {
//       setCurrentPage(page);
//     }
//   };

//   return (
//     <div className="container mt-4">
//       <div className="table-responsive">
//         {isloading ? (
//           <div
//             style={{
//               position: "fixed",
//               top: 0,
//               left: 0,
//               width: "100%",
//               height: "100%",
//               backgroundColor: "rgba(0, 0, 0, 0.3)",
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//               zIndex: 9999,
//             }}
//           >
//             <div className="loadergif">
//               <img src={loadergif} alt="Loading..." />
//             </div>
//           </div>
//         ) : (
//           ""
//         )}

//         <div className="d-flex flex-row align-items-center gap-3 flex-wrap pb-3 pt-4">
//           <div className="d-flex align-items-center">
//             <label className="me-2">Search</label>
//             <input
//               type="text"
//               className="form-control"
//               placeholder="Search..."
//               value={searchQuery}
//               onChange={(e) => {
//                 setSearchQuery(e.target.value);
//                 setCurrentPage(1);
//               }}
//               style={{ width: "200px" }}
//             />
//           </div>
//           <div className="d-flex gap-2">
//             <Button
//             variant="contained"
//             color={selectedFilter === "inprogress" ? "success" : "primary"}
//             onClick={() => handleButtonClick("inprogress")}
//           >
//             Pending
//           </Button>

//           <Button
//             variant="contained"
//             color={selectedFilter === "accepted" ? "success" : "primary"}
//             onClick={() => handleButtonClick("accepted")}
//           >
//             Accepted
//           </Button>
//           <Button
//             variant="contained"
//             color={selectedFilter === "rejected" ? "success" : "primary"}
//             onClick={() => handleButtonClick("rejected")}
//           >
//             Rejected
//           </Button>
//           </div>
//         </div>

//         <table className="table table-bordered table-striped custom-table">
//           <thead className="thead-dark">
//             <tr>
//               <th>SW Id</th>
//               <th>Download Excel</th>
//               <th>Idea Category</th>
//               <th>Proposed Idea</th>
//               {approverNames.map((name) => (
//                 <th key={name}>{name}</th>
//               ))}
//             </tr>
//           </thead>
//           <tbody>
//             {currentData.length === 0 ? (
//               <tr>
//                 <td colSpan="9" className="text-center py-4">
//                   No ideas found
//                 </td>
//               </tr>
//             ) : (
//               currentData.map((req, index) => (
//                 <tr key={req.id_x}>
//                   <td>{req.idea_unique_id}</td>
//                   <td
//                     style={{ cursor: "pointer" }}
//                     onClick={() => downloadApi(req)}
//                   >
//                     <DownloadIcon />
//                   </td>

//                   <td>{req.idea_category_x}</td>
//                   <Tooltip title={req.proposed_idea || ""} arrow>
//                     <td>
//                       {req.proposed_idea_x?.slice(0, 15)}
//                       {req.proposed_idea_x?.length > 15 ? "..." : ""}
//                     </td>
//                   </Tooltip>
//                   {approverNames.map((name, i) => {
//                     const approver = req.approvers.find((a) => a.name === name);
//                     return (
//                       <td key={i}>
//                         {approver ? (
//                           <StatusDot
//                             status={approver.status}
//                             name={approver.name}
//                             onClick={() => handleDotClick(req, approver)}
//                           />
//                         ) : (
//                           "-"
//                         )}
//                       </td>
//                     );
//                   })}
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>

//       <Dialog
//         open={openDialog}
//         onClose={handleCloseDialog}
//         maxWidth="sm"
//         fullWidth
//       >
//         <DialogTitle>Approver Status Details</DialogTitle>
//         <DialogContent dividers>
//           <AlertDialogForm
//             request={selectedRequest}
//             approver={selectedApprover}
//           />
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCloseDialog} color="primary">
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Pagination Controls */}
//       <Stack alignItems="center" marginTop={3} color="white">
//         <Pagination
//           count={totalPages}
//           page={currentPage}
//           onChange={(event, value) => handlePageChange(value)}
//           color="primary"
//           variant="outlined"
//           shape="circular"
//           sx={{
//             "& .MuiPaginationItem-root": {
//               color: "black",
//               borderColor: "black",
//               backgroundColor: "white",
//             },
//             "& .Mui-selected": {
//               backgroundColor: "green",
//               color: "white",
//               "&:hover": {
//                 backgroundColor: "darkgreen",
//               },
//             },
//             "& .MuiPaginationItem-root:hover": {
//               backgroundColor: "#f0f0f0",
//             },
//           }}
//         />
//       </Stack>
//     </div>
//   );
// };

// export default IdeaTable;

import React, { useState, useEffect } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import {
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";

import { Pagination, Stack } from "@mui/material";
import AlertDialogForm from "./alertdialog";
import {
  GETIL2BYEMPID,
  VAVE,
  DOWNLOAD2B2FILE,
} from "../../../Pages/AppConstant";
import approvedImage from "../../../assets/images/approved_image.jpg";
import rejectedImage from "../../../assets/images/rejected_image.jpg";
import DownloadIcon from "@mui/icons-material/Download";
import ExcelJS from "exceljs";
import loadergif from "../../../assets/images/BG-switch loader_2.gif";

const getStatusColor = (status) => {
  switch (status) {
    case "accepted":
      return "green";
    case "rejected":
      return "red";
    case "pending":
      return "orange";
    default:
      return "gray";
  }
};

const StatusDot = ({ status, name, onClick }) => (
  <Tooltip title={`Status: ${status} (${name})`} arrow>
    <span
      onClick={onClick}
      style={{
        display: "inline-block",
        width: "22px",
        height: "22px",
        borderRadius: "50%",
        backgroundColor: getStatusColor(status),
        margin: "auto",
        cursor: "pointer",
      }}
    />
  </Tooltip>
);

const IdeaTable = ({ requests }) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [selectedApprover, setSelectedApprover] = useState(null);
  const [allIdeas, setAllIdeas] = useState([]);
  const [isloading, setIsloading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Change as needed
  const [searchQuery, setSearchQuery] = useState("");

  const [selectedFilter, setSelectedFilter] = useState("all");

  const isIdeaUpdatedToday = (idea) => {
    if (!idea?.url_2b2_created_timestamp) return false;

    const updatedDate = new Date(idea.url_2b2_created_timestamp)
      .toISOString()
      .split("T")[0];

    return updatedDate === "2025-11-20";
  };

  const addStampImageToCell = async (
    workbook,
    worksheet,
    row,
    col,
    isApproved,
  ) => {
    try {
      const imageUrl = isApproved ? approvedImage : rejectedImage;

      // Convert the imported image to a blob URL or base64
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const arrayBuffer = await blob.arrayBuffer();

      const imageId = workbook.addImage({
        buffer: arrayBuffer,
        extension: "png",
      });

      worksheet.addImage(imageId, {
        tl: { col: col - 1, row: row - 1, offset: 2 }, // 2px offset from top-left
        br: { col: col, row: row, offset: 2 }, // 2px offset from bottom-right
      });
    } catch (error) {
      console.error("Error adding stamp image:", error);
    }
  };

  const handleDotClick = (req, approver) => {
    setSelectedRequest(req);
    setSelectedApprover(approver);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const downloadApi = async (request) => {
    try {
      setIsloading(true);
      // Fetch the uploaded Excel file from API
      const response = await axios({
        method: "post",
        url: VAVE + DOWNLOAD2B2FILE,
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: { idea_id: request.ideaids },
        responseType: "blob",
      });

      if (response.data.size === 14) {
        alert("No Data Available");
        setIsloading(false);
        return;
      }

      // Load the uploaded Excel file
      const workbook = new ExcelJS.Workbook();
      const arrayBuffer = await response.data.arrayBuffer();
      await workbook.xlsx.load(arrayBuffer);

      const worksheet = workbook.getWorksheet(1);

      const currentIdea = allIdeas.find(
        (idea) =>
          idea.idea_unique_id === request.idea_unique_id ||
          idea.idea_id === request.ideaids,
      );

      if (currentIdea) {
        const isUpdatedToday = isIdeaUpdatedToday(currentIdea);

        if (isUpdatedToday) {
          // alert("today" + isUpdatedToday);
          await addOldStampImagesToWorksheet(workbook, worksheet, request);
        } else {
          //  alert("not-today" + isUpdatedToday);
          updateWorksheetStamps(worksheet, request);

          await addStampImagesToWorksheet(workbook, worksheet, request);
        }
      }

      // await addStampImagesToWorksheet(workbook, worksheet, request);
      // await addStampImagesToWorksheet(workbook, worksheet, request);

      // Export and download the modified worksheet
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `Idea_${request.idea_unique_id}_Report.xlsx`,
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      setIsloading(false);
    } catch (error) {
      console.error("Download failed:", error);
      alert("Download failed: " + error.message);
      setIsloading(false);
    }
  };

  const addOldStampImagesToWorksheet = async (workbook, worksheet, idea) => {
    try {
      console.log("Adding stamp images to worksheet");

      // PD Department Stamp
      if (
        idea.il2_pd_status &&
        idea.il2_pd_status.toLowerCase() !== "inprogress"
      ) {
        const isApproved =
          idea.il2_pd_status.toLowerCase() === "accepted" ||
          idea.il2_pd_status.toLowerCase() === "approved";
        await addStampImageToCell(workbook, worksheet, 79, 12, isApproved); // H68
      }

      // S&SC Department Stamp
      if (
        idea.il2_sourcing_status &&
        idea.il2_sourcing_status.toLowerCase() !== "inprogress"
      ) {
        const isApproved =
          idea.il2_sourcing_status.toLowerCase() === "accepted" ||
          idea.il2_sourcing_status.toLowerCase() === "approved";
        await addStampImageToCell(workbook, worksheet, 79, 14, isApproved); // J68
      }

      // Marketing Department Stamp
      if (
        idea.il2_marketing_status &&
        idea.il2_marketing_status.toLowerCase() !== "inprogress"
      ) {
        const isApproved =
          idea.il2_marketing_status.toLowerCase() === "accepted" ||
          idea.il2_marketing_status.toLowerCase() === "approved";
        await addStampImageToCell(workbook, worksheet, 79, 18, isApproved); // N68
      }

      // Quality Department Stamp
      if (
        idea.il2_quality_status &&
        idea.il2_quality_status.toLowerCase() !== "inprogress"
      ) {
        const isApproved =
          idea.il2_quality_status.toLowerCase() === "accepted" ||
          idea.il2_quality_status.toLowerCase() === "approved";
        await addStampImageToCell(workbook, worksheet, 79, 22, isApproved); // R68
      }

      //finance
      if (
        idea.il2_costing_status &&
        idea.il2_costing_status.toLowerCase() !== "inprogress"
      ) {
        const isApproved =
          idea.il2_costing_status.toLowerCase() === "accepted" ||
          idea.il2_costing_status.toLowerCase() === "approved";
        await addStampImageToCell(workbook, worksheet, 79, 20, isApproved); // R68
      }
      //manuf
      if (
        idea.il2_manuf_status &&
        idea.il2_manuf_status.toLowerCase() !== "inprogress"
      ) {
        const isApproved =
          idea.il2_manuf_status.toLowerCase() === "accepted" ||
          idea.il2_manuf_status.toLowerCase() === "approved";
        await addStampImageToCell(workbook, worksheet, 79, 16, isApproved); // R68
      }
      console.log("Stamp images added successfully");
    } catch (error) {
      console.error("Error adding stamp images:", error);
    }
  };

  const addStampImagesToWorksheet = async (workbook, worksheet, idea) => {
    try {
      console.log("Adding stamp images to worksheet");

      // PD Department Stamp
      if (
        idea.il2_pd_status &&
        idea.il2_pd_status.toLowerCase() !== "inprogress"
      ) {
        const isApproved =
          idea.il2_pd_status.toLowerCase() === "accepted" ||
          idea.il2_pd_status.toLowerCase() === "approved";
        await addStampImageToCell(workbook, worksheet, 68, 8, isApproved); // H68
      }

      // S&SC Department Stamp
      if (
        idea.il2_sourcing_status &&
        idea.il2_sourcing_status.toLowerCase() !== "inprogress"
      ) {
        const isApproved =
          idea.il2_sourcing_status.toLowerCase() === "accepted" ||
          idea.il2_sourcing_status.toLowerCase() === "approved";
        await addStampImageToCell(workbook, worksheet, 68, 10, isApproved); // J68
      }

      // Marketing Department Stamp
      if (
        idea.il2_marketing_status &&
        idea.il2_marketing_status.toLowerCase() !== "inprogress"
      ) {
        const isApproved =
          idea.il2_marketing_status.toLowerCase() === "accepted" ||
          idea.il2_marketing_status.toLowerCase() === "approved";
        await addStampImageToCell(workbook, worksheet, 68, 14, isApproved); // N68
      }

      // Quality Department Stamp
      if (
        idea.il2_quality_status &&
        idea.il2_quality_status.toLowerCase() !== "inprogress"
      ) {
        const isApproved =
          idea.il2_quality_status.toLowerCase() === "accepted" ||
          idea.il2_quality_status.toLowerCase() === "approved";
        await addStampImageToCell(workbook, worksheet, 68, 18, isApproved); // R68
      }

      //finance
      if (
        idea.il2_costing_status &&
        idea.il2_costing_status.toLowerCase() !== "inprogress"
      ) {
        const isApproved =
          idea.il2_costing_status.toLowerCase() === "accepted" ||
          idea.il2_costing_status.toLowerCase() === "approved";
        await addStampImageToCell(workbook, worksheet, 68, 16, isApproved); // R68
      }
      //manuf
      if (
        idea.il2_manuf_status &&
        idea.il2_manuf_status.toLowerCase() !== "inprogress"
      ) {
        const isApproved =
          idea.il2_manuf_status.toLowerCase() === "accepted" ||
          idea.il2_manuf_status.toLowerCase() === "approved";
        await addStampImageToCell(workbook, worksheet, 68, 12, isApproved); // R68
      }
      console.log("Stamp images added successfully");
    } catch (error) {
      console.error("Error adding stamp images:", error);
    }
  };

  const updateWorksheetStamps = (worksheet, idea) => {
    try {
      console.log("Updating worksheet with idea data:", idea);

      // PD Department - Only update values, preserve all existing styles
      if (
        idea.il2_pd_status &&
        idea.il2_pd_status.toLowerCase() !== "inprogress"
      ) {
        const isApproved =
          idea.il2_pd_status.toLowerCase() === "accepted" ||
          idea.il2_pd_status.toLowerCase() === "approved";

        // Update comment cell - only value
        const commentCell = worksheet.getCell(66, 8);
        commentCell.value = idea.il2_pd_comment || "";

        // Update status cell - only value
        const statusCell = worksheet.getCell(68, 8);
        statusCell.value = `${isApproved ? "APPROVED" : "REJECTED"}\nby ${
          idea.il2_pd_name || ""
        }`;

        // Only ensure wrap text is enabled
        statusCell.alignment = { ...statusCell.alignment, wrapText: true };
      } else {
        const statusCell = worksheet.getCell(68, 8);
        statusCell.value = idea.il2_pd_status || "";
      }

      // S&SC Department
      if (
        idea.il2_sourcing_status &&
        idea.il2_sourcing_status.toLowerCase() !== "inprogress"
      ) {
        const isApproved =
          idea.il2_sourcing_status.toLowerCase() === "accepted" ||
          idea.il2_sourcing_status.toLowerCase() === "approved";

        const commentCell = worksheet.getCell(66, 10);
        commentCell.value = idea.il2_sourcing_comment || "";

        const statusCell = worksheet.getCell(68, 10);
        statusCell.value = `${isApproved ? "APPROVED" : "REJECTED"}\nby ${
          idea.il2_sourcing_name || ""
        }`;
        statusCell.alignment = { ...statusCell.alignment, wrapText: true };
      } else {
        const statusCell = worksheet.getCell(68, 10);
        statusCell.value = idea.il2_sourcing_status || "";
      }

      // Marketing Department
      if (
        idea.il2_marketing_status &&
        idea.il2_marketing_status.toLowerCase() !== "inprogress"
      ) {
        const isApproved =
          idea.il2_marketing_status.toLowerCase() === "accepted" ||
          idea.il2_marketing_status.toLowerCase() === "approved";

        const commentCell = worksheet.getCell(66, 14);
        commentCell.value = idea.il2_marketing_comment || "";

        const statusCell = worksheet.getCell(68, 14);
        statusCell.value = `${isApproved ? "APPROVED" : "REJECTED"}\nby ${
          idea.il2_marketing_name || ""
        }`;
        statusCell.alignment = { ...statusCell.alignment, wrapText: true };
      } else {
        const statusCell = worksheet.getCell(68, 14);
        statusCell.value = idea.il2_marketing_status || "";
      }

      // Quality Department
      if (
        idea.il2_quality_status &&
        idea.il2_quality_status.toLowerCase() !== "inprogress"
      ) {
        const isApproved =
          idea.il2_quality_status.toLowerCase() === "accepted" ||
          idea.il2_quality_status.toLowerCase() === "approved";

        const commentCell = worksheet.getCell(66, 18);
        commentCell.value = idea.il2_quality_comment || "";

        const statusCell = worksheet.getCell(68, 18);
        statusCell.value = `${isApproved ? "APPROVED" : "REJECTED"}\nby ${
          idea.il2_quality_name || ""
        }`;
        statusCell.alignment = { ...statusCell.alignment, wrapText: true };
      } else {
        const statusCell = worksheet.getCell(68, 18);
        statusCell.value = idea.il2_quality_status || "";
      }

      if (
        idea.il2_manuf_status &&
        idea.il2_manuf_status.toLowerCase() !== "inprogress"
      ) {
        const isApproved =
          idea.il2_manuf_status.toLowerCase() === "accepted" ||
          idea.il2_manuf_status.toLowerCase() === "approved";

        const commentCell = worksheet.getCell(66, 12);
        commentCell.value = idea.il2_manuf_comment || "";

        const statusCell = worksheet.getCell(68, 12);
        statusCell.value = `${isApproved ? "APPROVED" : "REJECTED"}\nby ${
          idea.il2_manuf_name || ""
        }`;
        statusCell.alignment = { ...statusCell.alignment, wrapText: true };
      } else {
        const statusCell = worksheet.getCell(68, 12);
        statusCell.value = idea.il2_manuf_status || "";
      }

      if (
        idea.il2_costing_status &&
        idea.il2_costing_status.toLowerCase() !== "inprogress"
      ) {
        const isApproved =
          idea.il2_costing_status.toLowerCase() === "accepted" ||
          idea.il2_costing_status.toLowerCase() === "approved";

        const commentCell = worksheet.getCell(66, 16);
        commentCell.value = idea.il2_costing_comment || "";

        const statusCell = worksheet.getCell(68, 16);
        statusCell.value = `${isApproved ? "APPROVED" : "REJECTED"}\nby ${
          idea.il2_costing_name || ""
        }`;
        statusCell.alignment = { ...statusCell.alignment, wrapText: true };
      } else {
        const statusCell = worksheet.getCell(68, 16);
        statusCell.value = idea.il2_costing_status || "";
      }
    } catch (error) {
      console.error("Error updating worksheet stamps:", error);
    }
  };
  useEffect(() => {
    fetchIdeas();
  }, []);

  const fetchIdeas = async () => {
    try {
      const response = await axios.get(VAVE + GETIL2BYEMPID, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });

      const ideas = response.data.data || [];
      setAllIdeas(ideas);
    } catch (error) {
      console.error("Error fetching ideas:", error);
    }
  };

  const ideaExcelDownloadSubmit = async () => {
    try {
      const res = await axios.get(VAVE + GETIL2BYEMPID);
      const ideas = res.data.data || [];

      const filteredData = ideas.map((item) => ({
        Sw_Id: `SWON-${item.id_x}`,
        idea_category: item.idea_category_x,
        partno: item.partno,
        part_description: item.part_description,
        benefit:item.benefit,
        idea_effective:item.idea_effective,
        model:item.model,
        varient:item.varient,
        subvarient:item.subvarient,
        il3_pd_status: item.il2_pd_status,
        il3_sourcing_status: item.il2_sourcing_status,
        il3_pd_comment: item.il2_pd_comment,
        il3_sourcing_comment: item.il2_sourcing_comment,

        il3_marketing_status: item.il2_marketing_status,
        il3_marketing_comment: item.il2_marketing_comment,
        il3_quality_comment: item.il2_quality_comment,
        il3_quality_status: item.il2_quality_status,
        il3_manuf_status: item.il2_manuf_status,
        il3_manuf_comment: item.il2_sourcing_comment,
        il3_costing_status: item.il2_costing_status,
        il3_costing_comment: item.il2_costing_comment,
      }));

      const worksheet = XLSX.utils.json_to_sheet(filteredData);

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Ideas");

      XLSX.writeFile(workbook, "IL3 Stage.xlsx");
    } catch (error) {
      console.error("Error generating Excel:", error);
    }
  };

  const updatedRequests = allIdeas.map((req) => {
    const approvers = [];

    if (req.il2_pd_name) {
      approvers.push({
        name: req.il2_pd_name,
        status: req.il2_pd_status,
        comment: req.il2_pd_comment,
        role: "PD",
      });
    }

    if (req.il2_sourcing_name) {
      approvers.push({
        name: req.il2_sourcing_name,
        status: req.il2_sourcing_status,
        comment: req.il2_sourcing_comment,
        role: "Sourcing",
      });
    }

    if (req.il2_marketing_name) {
      approvers.push({
        name: req.il2_marketing_name,
        status: req.il2_marketing_status,
        comment: req.il2_marketing_comment,
        role: "Marketing",
      });
    }

    if (req.il2_quality_name) {
      approvers.push({
        name: req.il2_quality_name,
        status: req.il2_quality_status,
        comment: req.il2_quality_comment,
        role: "Quality",
      });
    }

    if (req.il2_manuf_name) {
      approvers.push({
        name: req.il2_manuf_name,
        status: req.il2_manuf_status,
        comment: req.il2_manuf_comment,
        role: "Manuf",
      });
    }

    if (req.il2_costing_name) {
      approvers.push({
        name: req.il2_costing_name,
        status: req.il2_costing_status,
        comment: req.il2_costing_comment,
        role: "Costing",
      });
    }

    // ✅ Determine overall status
    // let overallStatus = "In Progress";
    // if (approvers.some((a) => a.status === "rejected")) {
    //   overallStatus = "Rejected";
    // } else if (approvers.every((a) => a.status === "accepted")) {
    //   overallStatus = "Completed";
    // }

    return {
      ...req,
      approvers,
      // overallStatus, // ✅ Add this field
    };
  });

  // const updatedRequests = allIdeas.map((req) => {
  //   const approvers = [];

  //   if (req.il2_pd_name) {
  //     approvers.push({
  //       name: req.il2_pd_name,
  //       status: req.il2_pd_status,
  //       comment: req.il2_pd_comment,
  //       role: "PD",
  //     });
  //   }

  //   if (req.il2_sourcing_name) {
  //     approvers.push({
  //       name: req.il2_sourcing_name,
  //       status: req.il2_sourcing_status,
  //       comment: req.il2_sourcing_comment,
  //       role: "Sourcing",
  //     });
  //   }

  //   if (req.il2_marketing_name) {
  //     approvers.push({
  //       name: req.il2_marketing_name,
  //       status: req.il2_marketing_status,
  //       comment: req.il2_marketing_comment,
  //       role: "Marketing",
  //     });
  //   }

  //   if (req.il2_quality_name) {
  //     approvers.push({
  //       name: req.il2_quality_name,
  //       status: req.il2_quality_status,
  //       comment: req.il2_quality_comment,
  //       role: "Quality",
  //     });
  //   }

  //   if (req.il2_manuf_name) {
  //     approvers.push({
  //       name: req.il2_manuf_name,
  //       status: req.il2_manuf_status,
  //       comment: req.il2_manuf_comment,
  //       role: "Manuf",
  //     });
  //   }

  //   if (req.il2_costing_name) {
  //     approvers.push({
  //       name: req.il2_costing_name,
  //       status: req.il2_costing_status,
  //       comment: req.il2_costing_comment,
  //       role: "Costing",
  //     });
  //   }

  //   return {
  //     ...req,
  //     approvers,
  //   };
  // });

  const approverNames = Array.from(
    new Set(
      updatedRequests.flatMap((req) =>
        req.approvers.map((approver) => approver.name || approver.role),
      ),
    ),
  );

  const totalPages = Math.ceil(updatedRequests.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;

  const filteredIdeas = updatedRequests.filter((item) => {
    const query = searchQuery.toLowerCase();
    const matchesSearch = Object.values(item).some((value) =>
      String(value).toLowerCase().includes(query),
    );

    const matchesFilter =
      selectedFilter === "all" ||
      (selectedFilter === "accepted" &&
        [
          "il2_costing_status",
          "il2_pd_status",
          "il2_sourcing_status",
          "il2_manuf_status",
          "il2_quality_status",
          "il2_marketing_status",
        ].every((status) => item[status] === "accepted")) ||
      (selectedFilter === "rejected" &&
        [
          "il2_costing_status",
          "il2_pd_status",
          "il2_sourcing_status",
          "il2_manuf_status",
          "il2_quality_status",
          "il2_marketing_status",
        ].some((status) => item[status] === "rejected"));

    return matchesSearch && matchesFilter;
  });

  const currentData = filteredIdeas.slice(
    startIndex,
    startIndex + itemsPerPage,
  );

  const handleButtonClick = (filter) => {
    setSelectedFilter(filter);
    setCurrentPage(1); // Reset pagination
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

// 🔧 Normalize helper
const norm = (s) => (s || "").toString().trim().toLowerCase();

// The six IL2 status fields you’re already using
const statusFields = [
  "il2_costing_status",
  "il2_pd_status",
  "il2_sourcing_status",
  "il2_manuf_status",
  "il2_quality_status",
  "il2_marketing_status",
];

const { totalAccepted, totalRejected } = React.useMemo(() => {
  let accepted = 0;
  let rejected = 0;

  allIdeas.forEach((item) => {
    const isAccepted = statusFields.every((field) => norm(item[field]) === "accepted");
    const isRejected = statusFields.some((field) => norm(item[field]) === "rejected");
    if (isAccepted) accepted++;
    if (isRejected) rejected++;
  });

  return { totalAccepted: accepted, totalRejected: rejected };
}, [updatedRequests]);

  return (
    <div className="container mt-4">
      <div className="table-responsive">
        {isloading ? (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.3)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <div className="loadergif">
              <img src={loadergif} alt="Loading..." />
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="d-flex flex-row align-items-center gap-3 flex-wrap pb-3 pt-4">
          <div className="d-flex align-items-center">
            <label className="me-2">Search</label>
            <input
              type="text"
              className="form-control"
              placeholder="Search..."
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                setCurrentPage(1);
              }}
              style={{ width: "200px" }}
            />
          </div>
          <div className="d-flex gap-2">
            <button
              type="button"
              className="btn btn-primary"
              onClick={ideaExcelDownloadSubmit}
            >
              Download IL3 Excel
            </button>
            <Button
              variant="contained"
              color={selectedFilter === "all" ? "success" : "primary"}
              onClick={() => handleButtonClick("all")}
            >
              All (Total Ideas: {allIdeas.length})
            </Button>

            <Button
              variant="contained"
              color={selectedFilter === "accepted" ? "success" : "primary"}
              onClick={() => handleButtonClick("accepted")}
            >
              Accepted ({totalAccepted})
            </Button>
            <Button
              variant="contained"
              color={selectedFilter === "rejected" ? "success" : "primary"}
              onClick={() => handleButtonClick("rejected")}
            >
              Rejected ({totalRejected})
            </Button>
          </div>
        </div>

        <table className="table table-bordered table-striped custom-table">
          <thead className="thead-dark">
            <tr>
              <th>SW Id</th>
              <th>Download Excel</th>
              <th>Idea Category</th>
              <th>Proposed Idea</th>
              {approverNames.map((name) => (
                <th key={name}>{name}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {currentData.length === 0 ? (
              <tr>
                <td colSpan="9" className="text-center py-4">
                  No ideas found
                </td>
              </tr>
            ) : (
              currentData.map((req, index) => (
                <tr key={req.id_x}>
                  <td>{req.idea_unique_id}</td>
                  <td
                    style={{ cursor: "pointer" }}
                    onClick={() => downloadApi(req)}
                  >
                    <DownloadIcon />
                  </td>

                  <td>{req.idea_category_x}</td>
                  <Tooltip title={req.proposed_idea || ""} arrow>
                    <td>
                      {req.proposed_idea_x?.slice(0, 15)}
                      {req.proposed_idea_x?.length > 15 ? "..." : ""}
                    </td>
                  </Tooltip>
                  {approverNames.map((name, i) => {
                    const approver = req.approvers.find((a) => a.name === name);
                    return (
                      <td key={i}>
                        {approver ? (
                          <StatusDot
                            status={approver.status}
                            name={approver.name}
                            onClick={() => handleDotClick(req, approver)}
                          />
                        ) : (
                          "-"
                        )}
                      </td>
                    );
                  })}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Approver Status Details</DialogTitle>
        <DialogContent dividers>
          <AlertDialogForm
            request={selectedRequest}
            approver={selectedApprover}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Pagination Controls */}
      <Stack alignItems="center" marginTop={3} color="white">
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={(event, value) => handlePageChange(value)}
          color="primary"
          variant="outlined"
          shape="circular"
          sx={{
            "& .MuiPaginationItem-root": {
              color: "black",
              borderColor: "black",
              backgroundColor: "white",
            },
            "& .Mui-selected": {
              backgroundColor: "green",
              color: "white",
              "&:hover": {
                backgroundColor: "darkgreen",
              },
            },
            "& .MuiPaginationItem-root:hover": {
              backgroundColor: "#f0f0f0",
            },
          }}
        />
      </Stack>
    </div>
  );
};

export default IdeaTable;
